import { observer } from 'mobx-react-lite'
import ShareDocumentDialogExportStore from '../export/ShareDocumentDialogExportStore'
import GapAutocompleteSingle from 'features/gap-components/autocomplete/single/GapAutocompleteSingle'
import { useShareDocumentDialogStore } from '../ShareDocumentDialogStore'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import Typography from "@mui/material/Typography"

interface ShareDocumentDialogFYISelectClientProps {
   shareDocumentDialogExportStore: ShareDocumentDialogExportStore
}

export default observer(function ShareDocumentDialogFYISelectClient(props: ShareDocumentDialogFYISelectClientProps) {
   const { shareDocumentDialogExportStore } = props
   const shareDocumentDialogStore = useShareDocumentDialogStore()
   const { advisorIntegrationFYIStore } = shareDocumentDialogExportStore.sp

   if (advisorIntegrationFYIStore.clientLoader.isLoading) {
      return <>
         <SkeletonLoader loading={true} sx={{ height: 56, transform: 'none', borderRadius: '8px' }} />
         <Typography variant="caption" color="text.secondary" sx={{ ml: '14px', mt: '4px' }}>Select the matching client in FYI Docs</Typography>
      </>
   }

   return shareDocumentDialogStore.formHandler.selectedFYIClientId.bindInput(ip =>
      <GapAutocompleteSingle
         sx={{ mt: 2 }}
         loading={advisorIntegrationFYIStore.clientLoader.isLoading}
         options={shareDocumentDialogExportStore.FYIClientOptions}
         label="Client*"
         value={ip.value}
         onChange={ip.onChange}
         helperText='Select the matching client in FYI Docs'
         error={ip.error}
      />
   )
})
